'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function setFieldFactory(fieldPath, fieldValue) {
  function setField(_ref) {
    var state = _ref.state,
        resolve = _ref.resolve;

    if (!resolve.isTag(fieldPath, 'state')) {
      throw new Error('Cerebral Forms - operator.setField: You have to use the STATE TAG as first argument');
    }

    state.merge(resolve.path(fieldPath), {
      value: resolve.value(fieldValue),
      isPristine: false
    });
  }

  return setField;
}

exports.default = setFieldFactory;
//# sourceMappingURL=setField.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cerebral/forms/lib/operators/setField.js
// module id = 1009
// module chunks = 5